import React, { Component } from "react";
import ISPClientDialog from "./ispClientDialog";

class ISPClientProfile extends Component {
  sortAdvisors = (a, b) => {
    if (a.Name < b.Name) return -1;
    if (a.Name > b.Name) return 1;
    return 0;
  };

  render() {
    const {
      values,
      onChange,
      lists,
      // Joint clients props
      jointClients,
      showClientDialog,
      dialogEditIndex,
      dialogCopySource,
      onAddClient,
      onEditClient,
      onCloseDialog,
      onSaveClient,
      onCopyClient,
      onRemoveClient,
      clientNameHistory,
      // Multi-advisor props
      additionalAdvisors = [],
      onAddAdvisor,
      onChangeAdvisor,
      onRemoveAdvisor,
    } = this.props;

    const isFusion =
      values.strategy && values.strategy.toLowerCase().includes("fusion");
    const allowsMultipleAccountNumbers =
      isFusion || values.existingRequestAction === "Fee Update";
    const showClientProfileIma =
      values.requestType === "New" ||
      (values.requestType === "Existing" &&
        values.existingRequestAction === "Strategy Change");
    const showHouseholding =
      values.requestType === "New" && values.householdingMode !== "disallowed";

    // A dynamic sub-section's wrapper stays grey until every required field it
    // reveals is filled in, then turns green.
    const accountNumbersComplete =
      values.requestType !== "Existing" ||
      (allowsMultipleAccountNumbers
        ? (values.accountNumbers || []).some((n) => (n || "").trim() !== "")
        : !!(values.accountNumber && values.accountNumber.length >= 4));
    const existingActionComplete =
      values.requestType !== "Existing" || !!values.existingRequestAction;
    const requestTypeComplete =
      !!values.requestType && existingActionComplete && accountNumbersComplete;
    // T19 — when the strategy disallows or defers householding, the prompt is
    // hidden entirely, so the bar should stay green without an answer.
    const householdingComplete =
      !showHouseholding ||
      (values.householding === "Yes" &&
        !!values.householdRefName &&
        !!values.householdRefLast4 &&
        values.householdRefLast4.length === 4) ||
      (values.householding === "No" &&
        values.householdReasonType &&
        (values.householdReasonType !== "Other" ||
          !!(values.householdReasonOther || "").trim()));

    const advisors = lists?.advisors || [];
    const sortedAdvisors = advisors
      .filter((a) => !a.Name.includes("@"))
      .sort(this.sortAdvisors);

    return (
      <div>
        {/* Investment Advisor Representative (IAR) Name(s) */}
        <div className="d-flex align-items-baseline mb-2">
          <label className="mb-0">
            <strong>Investment Advisor Representative (IAR) Name(s)</strong>
          </label>
          <button
            type="button"
            className="btn btn-sm btn-primary ml-3"
            onClick={onAddAdvisor}
          >
            + Add IAR
          </button>
        </div>
        <div className="mb-1">
          <select
            name="advisorName"
            className="form-control"
            style={{
              borderLeftColor: values.advisorName ? "green" : "#ced4da",
              borderLeftWidth: "5px",
            }}
            onChange={(e) => onChange("advisorName", e.target.value)}
            value={values.advisorName || ""}
          >
            <option value="">Select IAR</option>
            {sortedAdvisors.map((adv, index) => (
              <option value={adv.Name} key={index}>
                {adv.Name}
              </option>
            ))}
          </select>
          <small
            className="text-muted"
            style={{ fontSize: "11px", marginTop: "1px", display: "block" }}
          >
            Primary
          </small>
        </div>
        {additionalAdvisors.map((advName, index) => (
          <div className="d-flex align-items-center mb-1" key={index}>
            <select
              className="form-control"
              style={{
                borderLeftColor: advName ? "green" : "#ced4da",
                borderLeftWidth: "5px",
                flex: 1,
              }}
              value={advName}
              onChange={(e) => onChangeAdvisor(index, e.target.value)}
            >
              <option value="">Select IAR</option>
              {sortedAdvisors.map((adv, idx) => (
                <option value={adv.Name} key={idx}>
                  {adv.Name}
                </option>
              ))}
            </select>
            <button
              type="button"
              className="btn btn-sm btn-danger ml-2"
              style={{ padding: "2px 8px" }}
              onClick={() => onRemoveAdvisor(index)}
              title="Delete"
              aria-label="Delete IAR"
            >
              <i className="fa fa-trash" style={{ fontSize: "12px" }} />
            </button>
          </div>
        ))}

        {/* Request Type + Account Number(s) — the label sits outside the
            completeness bar, which wraps the choices and the account numbers
            revealed when "Existing" is selected. */}
        <div className="form-group">
          <label>
            <strong>Request Type</strong>
          </label>
          <div
            style={{
              borderLeft: `5px solid ${requestTypeComplete ? "green" : "#ced4da"}`,
              paddingLeft: "12px",
            }}
          >
            <div className="mt-1">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="requestType"
                  id="requestTypeNew"
                  value="New"
                  checked={values.requestType === "New"}
                  onChange={(e) => onChange("requestType", e.target.value)}
                  style={{ height: "15px", width: "15px" }}
                />
                <label className="form-check-label" htmlFor="requestTypeNew">
                  New Business
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="requestType"
                  id="requestTypeExisting"
                  value="Existing"
                  checked={values.requestType === "Existing"}
                  onChange={(e) => onChange("requestType", e.target.value)}
                  style={{ height: "15px", width: "15px" }}
                />
                <label
                  className="form-check-label"
                  htmlFor="requestTypeExisting"
                >
                  {isFusion
                    ? "Existing Accounts Update"
                    : "Existing Account Update"}
                </label>
              </div>
            </div>

            {/* Account Number(s) (conditional on Existing) */}
            {values.requestType === "Existing" && (
              <div className="form-group">
                <label className="d-block">
                  <strong>Account Update Type</strong>
                </label>
                {[
                  "Strategy Change",
                  "Risk Tolerance Update",
                  "Model Change",
                  "Fee Update",
                ].map((option) => (
                  <div className="form-check form-check-inline" key={option}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="existingRequestAction"
                      id={`existingRequestAction${option.replace(/\s/g, "")}`}
                      value={option}
                      checked={values.existingRequestAction === option}
                      onChange={(e) =>
                        onChange("existingRequestAction", e.target.value)
                      }
                      style={{ height: "15px", width: "15px" }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`existingRequestAction${option.replace(/\s/g, "")}`}
                    >
                      {option}
                    </label>
                  </div>
                ))}
                {allowsMultipleAccountNumbers ? (
                  <>
                    <label className="d-block mt-3 mb-1">
                      <strong>Account Number(s) (Last 4 digits)</strong>
                    </label>
                    {values.accountNumbers.map((acctNum, index) => (
                      <div key={index} style={{ marginBottom: "8px" }}>
                        <input
                          type="text"
                          className="form-control"
                          style={{
                            maxWidth: "150px",
                            borderLeftColor:
                              acctNum.trim() !== "" ||
                              (index > 0 &&
                                index === values.accountNumbers.length - 1)
                                ? "green"
                                : "#ced4da",
                            borderLeftWidth: "5px",
                          }}
                          maxLength={4}
                          value={acctNum}
                          onChange={(e) => {
                            const val = e.target.value.replace(
                              /[^0-9A-Za-z]/g,
                              "",
                            );
                            this.props.onAccountNumberChange(index, val);
                          }}
                          placeholder="####"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                            } else if (
                              !/[A-Za-z0-9]/.test(e.key) &&
                              e.key.length === 1
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    <label htmlFor="accountNumber" className="d-block mt-3 mb-1">
                      <strong>Account Number(s) (Last 4 digits)</strong>
                    </label>
                    <input
                      type="text"
                      id="accountNumber"
                      name="accountNumber"
                      className="form-control"
                      style={{
                        maxWidth: "150px",
                        borderLeftColor:
                          values.accountNumber &&
                          values.accountNumber.length >= 4
                            ? "green"
                            : "#ced4da",
                        borderLeftWidth: "5px",
                      }}
                      maxLength={4}
                      onChange={(e) => {
                        const val = e.target.value.replace(/[^0-9]/g, "");
                        onChange("accountNumber", val);
                      }}
                      value={values.accountNumber || ""}
                      placeholder="####"
                    />
                    {values.accountNumber &&
                      values.accountNumber.length > 0 &&
                      values.accountNumber.length < 4 && (
                        <small className="form-text text-danger">
                          Account number must be 4 digits.
                        </small>
                      )}
                  </>
                )}
              </div>
            )}
          </div>
        </div>

        {/* T1 — Client Profile / IMA attestation. "No" surfaces a long
            attestation paragraph on the PDF (built by api-isp-request.py)
            so the advisor isn't silently certifying client data without
            having a Client Profile + IMA on file. */}
        {showClientProfileIma && (
          <div className="form-group">
            <label>
              <strong>
                Will a Client Profile and IMA be submitted with this ISP?
              </strong>
            </label>
          <div
            className="mt-1"
            style={{
              borderLeft: `5px solid ${
                values.clientProfileImaSubmitted ? "green" : "#ced4da"
              }`,
              paddingLeft: "12px",
            }}
          >
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="clientProfileImaSubmitted"
                id="clientProfileImaYes"
                value="Yes"
                checked={values.clientProfileImaSubmitted === "Yes"}
                onChange={(e) =>
                  onChange("clientProfileImaSubmitted", e.target.value)
                }
                style={{ height: "15px", width: "15px" }}
              />
              <label className="form-check-label" htmlFor="clientProfileImaYes">
                Yes
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="clientProfileImaSubmitted"
                id="clientProfileImaNo"
                value="No"
                checked={values.clientProfileImaSubmitted === "No"}
                onChange={(e) =>
                  onChange("clientProfileImaSubmitted", e.target.value)
                }
                style={{ height: "15px", width: "15px" }}
              />
              <label className="form-check-label" htmlFor="clientProfileImaNo">
                No
              </label>
            </div>
          </div>
          {values.clientProfileImaSubmitted === "No" && (
            <small
              className="form-text text-muted mt-2"
              style={{ lineHeight: "1.5", fontStyle: "italic" }}
            >
              By selecting "No", you attest that you have reviewed the
              client(s)' current Client Profile &amp; Investment Management
              Agreement on file with Vicus Capital and confirm all client data
              is accurate and current. The full attestation will appear on the
              generated Investment Strategy Plan above the advisor's signature.
            </small>
          )}
          </div>
        )}

        {/* T19 — strategy-driven householding behavior. The selected
            strategy may disallow householding entirely (Managed Money Market
            Solutions). Deferred strategies (Elements) still collect Yes/NA,
            with a note that householding applies after graduation. */}
        {showHouseholding && (
          <div className="form-group">
            <label>
              <strong>Householding</strong>
            </label>
            {values.householdingMode === "deferred-with-note" && (
              <div
                className="alert alert-info py-2 mb-2"
                style={{ fontSize: "13px", lineHeight: "1.5" }}
              >
                Householding will not apply until account graduates to selected
                path.
              </div>
            )}
            <div
              style={{
                borderLeft: `5px solid ${householdingComplete ? "green" : "#ced4da"}`,
                paddingLeft: "12px",
              }}
            >
              <small className="form-text text-muted mb-2 d-block">
                I wish to household this account with other eligible accounts
                currently managed by Vicus Capital.
              </small>
              <div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="householding"
                    id="householdingYes"
                    value="Yes"
                    checked={values.householding === "Yes"}
                    onChange={(e) => onChange("householding", e.target.value)}
                    style={{ height: "15px", width: "15px" }}
                  />
                  <label className="form-check-label" htmlFor="householdingYes">
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="householding"
                    id="householdingNo"
                    value="No"
                    checked={values.householding === "No"}
                    onChange={(e) => onChange("householding", e.target.value)}
                    style={{ height: "15px", width: "15px" }}
                  />
                  <label className="form-check-label" htmlFor="householdingNo">
                    Not Applicable
                  </label>
                </div>
              </div>

              {values.householding === "Yes" && (
                // T8 — name + last-4 captured separately. The example account in
                // a household may be owned by a different client than the one
                // being submitted, so the name is not derivable from the joint
                // clients on this ISP and must be captured explicitly.
                <div className="form-group mt-2 mb-0">
                  <label className="d-block mb-1">
                    Existing account in household:
                  </label>
                  <div
                    className="d-flex"
                    style={{ gap: "12px", flexWrap: "wrap" }}
                  >
                    <div style={{ flex: "1 1 240px", minWidth: "200px" }}>
                      <input
                        type="text"
                        id="householdRefName"
                        className="form-control"
                        style={{
                          borderLeftColor: values.householdRefName
                            ? "green"
                            : "#ced4da",
                          borderLeftWidth: "5px",
                        }}
                        maxLength={120}
                        onChange={(e) =>
                          onChange("householdRefName", e.target.value)
                        }
                        value={values.householdRefName || ""}
                        placeholder="Account holder name"
                      />
                      <small className="form-text text-muted">
                        Name on Existing Account
                      </small>
                      <small className="form-text text-muted">
                        If Existing Account is currently being opened, please
                        enter "Client Name - New Account" in the Name field and
                        0000 in the Account Number field.
                      </small>
                    </div>
                    <div style={{ flex: "0 0 160px" }}>
                      <input
                        type="text"
                        id="householdRefLast4"
                        className="form-control"
                        style={{
                          borderLeftColor:
                            values.householdRefLast4 &&
                            values.householdRefLast4.length === 4
                              ? "green"
                              : "#ced4da",
                          borderLeftWidth: "5px",
                        }}
                        maxLength={4}
                        onChange={(e) => {
                          const val = e.target.value.replace(/[^0-9]/g, "");
                          onChange("householdRefLast4", val);
                        }}
                        value={values.householdRefLast4 || ""}
                        placeholder="####"
                      />
                      <small className="form-text text-muted">
                        Household Reference - Account Number
                      </small>
                    </div>
                  </div>
                  {values.householdRefLast4 &&
                    values.householdRefLast4.length > 0 &&
                    values.householdRefLast4.length < 4 && (
                      <small className="form-text text-danger">
                        Account number must be 4 digits.
                      </small>
                    )}
                </div>
              )}

              {values.householding === "No" && (
                <div className="form-group mt-2 mb-0">
                  <label>Provide reason:</label>
                  <div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="householdReasonType"
                        id="householdReasonOnly"
                        value="Only account"
                        checked={values.householdReasonType === "Only account"}
                        onChange={(e) =>
                          onChange("householdReasonType", e.target.value)
                        }
                        style={{ height: "15px", width: "15px" }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="householdReasonOnly"
                      >
                        This is the only account in the household.
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="householdReasonType"
                        id="householdReasonOther"
                        value="Other"
                        checked={values.householdReasonType === "Other"}
                        onChange={(e) =>
                          onChange("householdReasonType", e.target.value)
                        }
                        style={{ height: "15px", width: "15px" }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="householdReasonOther"
                      >
                        Other
                      </label>
                    </div>
                  </div>
                  {values.householdReasonType === "Other" && (
                    <>
                      <input
                        type="text"
                        id="householdReasonOtherText"
                        className="form-control mt-2"
                        style={{
                          borderLeftColor: values.householdReasonOther
                            ? "green"
                            : "#ced4da",
                          borderLeftWidth: "5px",
                        }}
                        onChange={(e) =>
                          onChange("householdReasonOther", e.target.value)
                        }
                        value={values.householdReasonOther || ""}
                        placeholder="Reason for not householding"
                        maxLength={200}
                      />
                      <small className="form-text text-muted text-right d-block">
                        {(values.householdReasonOther || "").length}/200
                      </small>
                    </>
                  )}
                </div>
              )}
            </div>

            <small
              className="form-text text-muted mt-2"
              style={{ lineHeight: "1.5" }}
            >
              Vicus Capital has the ability to offer a customized, blended
              Investment Management Fee based on the total assets under
              management held within a household. A household is defined as any
              spouse, domestic partner, and/or children who maintain accounts at
              the same registered address. Vicus Capital will calculate the
              collective sum of all assets held in accounts at your registered
              address and provide a blended fee schedule based on the assets
              held in each strategy. For further details, please reference the
              Vicus Capital Disclosure Document or Form ADV Part 2A.
            </small>
          </div>
        )}

        {/* Divider: account setup fields above, client names below */}
        <hr style={{ borderTop: "1px solid #dee2e6", margin: "20px 0" }} />

        {/* Joint Clients / Account Holders */}
        <div className="d-flex align-items-baseline mb-3">
          <label
            className="mb-0"
            style={{
              borderLeft: `5px solid ${
                jointClients.length > 0 && jointClients.some((c) => c.isPrimary)
                  ? "green"
                  : "#ced4da"
              }`,
              paddingLeft: "8px",
            }}
          >
            <strong>Client Name(s)</strong>
          </label>
          <button
            type="button"
            className="btn btn-sm btn-primary ml-3"
            onClick={onAddClient}
          >
            + Add Client
          </button>
        </div>

        {jointClients.length === 0 ? (
          <p className="text-muted">
            No clients added yet. Click "Add Client" to add an account holder.
          </p>
        ) : (
          <div
            className="table-responsive"
            style={{
              borderRadius: "6px",
              border: "1px solid #dee2e6",
              overflow: "hidden",
            }}
          >
            <table className="table table-striped mb-0">
              <thead style={{ backgroundColor: "#385EA4", color: "#fff" }}>
                <tr>
                  <th style={{ borderTop: "none" }}>Client Name</th>
                  <th style={{ borderTop: "none" }}>Role</th>
                  <th style={{ borderTop: "none" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {jointClients.map((client, index) => (
                  <tr
                    key={
                      client?.id ?? `${client?.clientName || "client"}-${index}`
                    }
                  >
                    <td>
                      <strong>{client.clientName}</strong>
                    </td>
                    <td>
                      {client.isPrimary ? (
                        <span
                          className="badge"
                          style={{
                            fontSize: "10px",
                            backgroundColor: "#385EA4",
                            color: "#fff",
                          }}
                        >
                          Primary
                        </span>
                      ) : (
                        <span
                          className="text-muted"
                          style={{ fontSize: "12px" }}
                        >
                          Account Holder
                        </span>
                      )}
                    </td>
                    <td>
                      <div className="d-flex">
                        <button
                          className="btn btn-sm mr-1"
                          style={{
                            backgroundColor: "#28a745",
                            color: "white",
                            padding: "2px 8px",
                          }}
                          onClick={() => onEditClient(index)}
                          title="Edit"
                          aria-label="Edit client"
                        >
                          <i
                            className="fa fa-pencil-square-o"
                            style={{ fontSize: "12px" }}
                          />
                        </button>
                        <button
                          className="btn btn-sm btn-primary mr-1"
                          style={{ padding: "2px 8px" }}
                          onClick={() => onCopyClient(index)}
                          title="Copy"
                          aria-label="Copy client"
                        >
                          <i
                            className="fa fa-copy"
                            style={{ fontSize: "12px" }}
                          />
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          style={{ padding: "2px 8px" }}
                          onClick={() => onRemoveClient(index)}
                          title="Delete"
                          aria-label="Delete client"
                        >
                          <i
                            className="fa fa-trash"
                            style={{ fontSize: "12px" }}
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Client Dialog Modal */}
        {showClientDialog && (
          <ISPClientDialog
            onClose={onCloseDialog}
            onSave={onSaveClient}
            isEditing={dialogEditIndex >= 0}
            clientNameHistory={clientNameHistory}
            editData={
              dialogEditIndex >= 0
                ? jointClients[dialogEditIndex]
                : dialogCopySource >= 0
                  ? { ...jointClients[dialogCopySource], isPrimary: false }
                  : null
            }
            defaultClientName=""
            isFirstClient={jointClients.length === 0 && dialogEditIndex < 0}
          />
        )}
      </div>
    );
  }
}

export default ISPClientProfile;
